import type { MemberRole } from '../api/client';

/**
 * Human-facing labels for the four org membership roles. `editor` renders as
 * "Project Manager" per the stakeholder-approved terminology. Keyed by the role
 * union so a new role forces a compile error until a label is added.
 */
export const ROLE_LABELS: Record<MemberRole, string> = {
  org_admin: 'Org Admin',
  editor: 'Project Manager',
  reviewer: 'Reviewer',
  viewer: 'Viewer',
};

/** The roles in display order (admin first). */
export const ROLE_ORDER: readonly MemberRole[] = ['org_admin', 'editor', 'reviewer', 'viewer'];

/** Returns the display label for a role, falling back to the raw value. */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role as MemberRole] ?? role;
}
